import { Dialog, Transition } from '@headlessui/react'
import { Fragment, useRef } from 'react'
import { useOnClickOutside } from 'usehooks-ts'
import { ButtonPrimary } from '../button'
import { Close } from '../icons'
import { Info } from '../icons/Info'

export type WarningLeagueModalProps = {
  open: boolean
  onClose: () => void
}

export const WarningLeagueModal = (props: WarningLeagueModalProps) => {
  const modalRef = useRef(null)

  const onClickOutsideModal = () => {
    props.onClose()
  }

  useOnClickOutside(modalRef, onClickOutsideModal)

  return (
    <>
      <Transition appear show={props.open} as={Fragment}>
        <Dialog as="div" className={'relative z-20'} open={props.open} onClose={props.onClose}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel
                  ref={modalRef}
                  className={
                    'rounded-lg bg-white overflow-hidden transform transition-all px-10 pt-10 pb-5 max-w-[700px] shadow-sm shadow-slate-400 relative flex flex-col gap-y-4'
                  }
                >
                  <div className="w-9 h-9 rounded-full bg-navy-900 bg-opacity-10 flex items-center justify-center ml-2 hover:bg-opacity-20 absolute right-4 top-4">
                    <Close onClick={props.onClose} />
                  </div>
                  <Dialog.Title
                    as="div"
                    className={'mb-4 text-xl font-medium text-navy-900 flex flex-row justify-between'}
                  >
                    <div className="font-bold">Registrant Contact Information Will Be Shared</div>
                  </Dialog.Title>
                  <Dialog.Description as="div" className={'mb-4 text-sm flex flex-col items-center gap-y-8'}>
                    <Info width="100" height="100" className="text-azul opacity-70" />
                    <div>
                      The Flex League format allows players to see each other’s emails and phone numbers. This allows
                      players to contact one another to schedule matches.
                    </div>
                  </Dialog.Description>
                  <div className="flex flex-col justify-center items-center">
                    <ButtonPrimary title="OK" onClick={props.onClose} className="w-20 h-10" />
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  )
}

export default WarningLeagueModal
